import { z } from "zod";

export const CotationPreferenceSchema = z.object({
  insuranceToggleDefault: z.boolean().default(false),
  winePriceDisplayToggle: z.boolean().default(false),
  woodBoxesToggle: z.boolean().default(false),
  woodBoxesDefault: z.number().min(6).max(12).default(12),
  otherFeesToggle: z.boolean().default(false),
  optionDapToggle: z.boolean().default(false),
});

export type CotationPreferenceData = z.infer<typeof CotationPreferenceSchema>;
